<div
  class="acp-root"
  [class.acp-root--open]="open"
  [class.acp-root--rtl]="isRTL"
>
  <div
    *ngIf="open"
    class="acp-backdrop"
    aria-hidden="true"
    (click)="onClose()"
  ></div>

  <div *ngIf="open" class="acp-shell">
    <aside
      class="acp-panel"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'DEVISE.MODAL.TITLE' | translate"
    >
      <!-- ======================== LIST VIEW ======================== -->
      <ng-container *ngIf="currentView === 'list'">
        <header class="acp__header">
          <span class="acp__header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                 stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M14.5 9a2.5 2 0 0 0-2.5-1.5c-1.4 0-2.5.7-2.5 2s1.1 1.7 2.5 2 2.5.9 2.5 2-1.1 2-2.5 2A2.5 2 0 0 1 9.5 15" />
              <path d="M12 6v1.5M12 16.5V18" />
            </svg>
          </span>
          <h2 class="acp__title">{{ "DEVISE.MODAL.TITLE" | translate }}</h2>
          <button type="button" class="acp__close" (click)="onClose()"
                  [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </header>

        <div class="acp__search">
          <input type="text" class="acp__search-input"
                 [(ngModel)]="searchTerm"
                 (ngModelChange)="onSearchChange()"
                 [placeholder]="'DEVISE.MODAL.SEARCH' | translate" />
        </div>

        <div class="acp__list">
          <div
            *ngIf="isLoading"
            class="acp__loader-wrap"
            role="status"
            [attr.aria-label]="'APP_BUTTONS.LOADING' | translate"
          >
            <span class="acp__loader" aria-hidden="true"></span>
          </div>

          <div *ngIf="!isLoading && filteredDevises.length === 0" class="acp__empty">
            {{ "DEVISE.MODAL.NO_DEVISES" | translate }}
          </div>

          <ng-container *ngIf="!isLoading">
            <div *ngFor="let devise of filteredDevises" class="acp__item">
              <span class="acp__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                     stroke-linejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" />
                  <path d="M14.5 9a2.5 2 0 0 0-2.5-1.5c-1.4 0-2.5.7-2.5 2s1.1 1.7 2.5 2 2.5.9 2.5 2-1.1 2-2.5 2A2.5 2 0 0 1 9.5 15" />
                  <path d="M12 6v1.5M12 16.5V18" />
                </svg>
              </span>

              <div class="acp__info">
                <span class="acp__name">{{ devise.libelle }}</span>
                <div class="acp__meta">
                  <span *ngIf="devise.code" class="acp__pill">{{ devise.code }}</span>

                  <label class="acp__toggle">
                    <input
                      type="checkbox"
                      class="acp__toggle-input"
                      [checked]="!devise.archived"
                      (change)="toggleArchive(devise)"
                    />
                    <span class="acp__toggle-track"></span>
                    <span class="acp__toggle-label" [class.acp__toggle-label--active]="!devise.archived">
                      {{ !devise.archived
                        ? ("DEVISE.MODAL.ACTIVE" | translate)
                        : ("DEVISE.MODAL.ARCHIVED" | translate) }}
                    </span>
                  </label>
                </div>
              </div>

              <div class="acp__actions">
                <button type="button" class="acp__action-btn"
                        (click)="openEditForm(devise)"
                        [attr.aria-label]="'APP_BUTTONS.EDIT' | translate">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round"
                       stroke-linejoin="round">
                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                    <path d="m15 5 4 4" />
                  </svg>
                </button>
                <button type="button" class="acp__action-btn acp__action-btn--danger"
                        (click)="deleteDevise(devise)"
                        [attr.aria-label]="'APP_BUTTONS.DELETE' | translate">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round"
                       stroke-linejoin="round">
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                  </svg>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <footer class="acp__footer">
          <button
            type="button"
            class="btn-pill btn-pill--primary"
            (click)="openCreateForm(); $event.stopPropagation()"
          >
            + {{ "DEVISE.MODAL.ADD" | translate }}
          </button>
        </footer>
      </ng-container>

      <!-- ======================== FORM VIEW ======================== -->
      <ng-container *ngIf="currentView === 'form'">
        <header class="acp__header">
          <button type="button" class="acp__back" (click)="backToList()"
                  [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
          <h2 class="acp__title">
            {{ isEditMode
              ? ("DEVISE.MODAL.FORM_TITLE_EDIT" | translate)
              : ("DEVISE.MODAL.FORM_TITLE_CREATE" | translate) }}
          </h2>
          <button type="button" class="acp__close" (click)="onClose()"
                  [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </header>

        <div class="acp__form-body" *ngIf="deviseForm" [formGroup]="deviseForm">
          <div
            *ngIf="isLoading"
            class="acp__loader-wrap acp__loader-wrap--form"
            role="status"
            [attr.aria-label]="'APP_BUTTONS.LOADING' | translate"
          >
            <span class="acp__loader" aria-hidden="true"></span>
          </div>

          <ng-container *ngIf="!isLoading">
            <!-- code -->
            <div class="acp__field">
              <label class="acp__label">{{ "DEVISE.FORM.CODE" | translate }}</label>
              <input type="text" class="acp__input"
                     [class.acp__input--invalid]="deviseForm.get('code')?.invalid && deviseForm.get('code')?.touched"
                     formControlName="code"
                     [placeholder]="'DEVISE.FORM.CODE' | translate" />
              <span class="acp__error"
                    *ngIf="deviseForm.get('code')?.invalid && deviseForm.get('code')?.touched">
                {{ "APP_PLACEHOLDER.FIELD_REQUIRED" | translate }}
              </span>
            </div>

            <!-- libelle -->
            <div class="acp__field">
              <label class="acp__label">{{ "DEVISE.FORM.LIBELLE" | translate }}</label>
              <input type="text" class="acp__input"
                     [class.acp__input--invalid]="deviseForm.get('libelle')?.invalid && deviseForm.get('libelle')?.touched"
                     formControlName="libelle"
                     [placeholder]="'DEVISE.FORM.LIBELLE' | translate" />
              <span class="acp__error"
                    *ngIf="deviseForm.get('libelle')?.invalid && deviseForm.get('libelle')?.touched">
                {{ "APP_PLACEHOLDER.FIELD_REQUIRED" | translate }}
              </span>
            </div>
          </ng-container>
        </div>

        <footer class="acp__form-footer">
          <button type="button" class="btn-pill btn-pill--secondary" (click)="backToList()">
            {{ "APP_BUTTONS.CANCEL" | translate }}
          </button>
          <button type="button" class="btn-pill btn-pill--primary"
                  [disabled]="isSaving" (click)="submitForm()"
                  [attr.aria-label]="isSaving ? ('APP_BUTTONS.LOADING' | translate) : ('APP_BUTTONS.SAVE' | translate)">
            <span *ngIf="isSaving" class="acp__btn-spinner" aria-hidden="true"></span>
            <span *ngIf="!isSaving">{{ "APP_BUTTONS.SAVE" | translate }}</span>
          </button>
        </footer>
      </ng-container>
    </aside>
  </div>
</div>
